import app from "./app.json";
import common from "./common.json";
import location from "./location.json";
import glossary from "./glossary.json";

export default {
  app: app,
  common: common,
  location: location,
  glossary: glossary,
};
